/* 曹操傳・第 3 章：濟北（192 年）
 * 一大片平野。曹操的營在西南；青州黃巾百萬之眾分成三座大營（北、東、東南），營裡都插著黃旗。 */
export const CAMPS = [[3600, 1200], [6600, 2000], [5200, 3900]];
export default {
  id: 'jibei', name: '濟北', W: 8000, H: 5200, seed: 192,
  bases: [[1000, 4200], [6600, 2000]],
  roads: [{ pts: [[1000, 4200], [2400, 3500], [3600, 2500], [CAMPS[0][0], CAMPS[0][1] + 200]], w: 140 }, { pts: [[3600, 2500], [5200, 2300], [CAMPS[1][0] - 200, CAMPS[1][1]]], w: 130 }, { pts: [[2400, 3500], [4000, 3800], [CAMPS[2][0] - 200, CAMPS[2][1]]], w: 130 }],
  rocks: [[2000, 1800, 380, 180], [5000, 1000, 360, 180], [6800, 3600, 380, 180], [3400, 4600, 360, 160]],
  woods: 0.3,
  sight: 0.8,
  clearings: CAMPS.map(([x, y]) => [x, y, 560]).concat([[1000, 4200, 500]]),
  fields: [[2600, 2600, 600, 300], [4600, 3000, 520, 260, '#86803f']],
  tents: CAMPS.map(([x, y]) => ({ x, y, n: 8, r: 420, chief: true })).concat([{ x: 1000, y: 4200, n: 6, r: 380, col: '#3b5a99', flag: '曹' }]),
  grass: [[3000, 3100, 260, 120], [4400, 2100, 260, 120], [5900, 3000, 260, 120], [4300, 4300, 240, 110]],
};
